/**
 * @exports cleanNumberString
 * @since 2.9.0
 */
import { CONVERTER_DEFAULTS } from '../CurrencyConverter/constants';

/**
 * Replace string decorations (e.g. dollar signs, letters, and thousand commas)
 * @param  {String|Number} num Number representation
 * @param  {String} [options.decimalSeparator] marks the decimal separator of the number
 * @return {String} representing a clean number string
 */
export const cleanNumberString = (num, { decimalSeparator = CONVERTER_DEFAULTS.decimalSeparator } = {}) => num.toString().replace(new RegExp(`[^\\d${decimalSeparator}-]`, 'g'), '');
